import { AfterViewInit, Component, ElementRef, Input } from '@angular/core';
import { RouterService } from 'src/app/services/router-service.service';

@Component({
	selector: 'app-no-data-row',
	templateUrl: './no-data-row.component.html',
	styleUrls: ['./no-data-row.component.scss']
})
export class NoDataRowComponent implements AfterViewInit {

	@Input() captionInnerHtml! : string;
	@Input() url! : string;

	constructor(private elementRef:ElementRef,
				private routerService:RouterService) {
	}

	ngAfterViewInit() {
		const link = this.elementRef.nativeElement.querySelector("a");
		if (link)
			link.addEventListener("click", ()=> { this.routerService.toUrl(this.url) });
	}
}